import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { Box, Collapse, useTheme } from "@mui/material";
import * as React from "react";

import {
  RobotoCheckbox,
  RobotoTableCell,
  RobotoTableRow,
  TagList,
  TooltipIconButton,
} from "@/shared/components";
import { EventDetails } from "@/shared/components/events/EventDetails";
import { EventScope } from "@/shared/components/EventScope";
import { RobotoPrincipalUnderlineLink } from "@/shared/components/principal/RobotoPrincipalUnderlineLink";
import { FormattedDateTime } from "@/shared/datetime";
import { EventRecord } from "@/shared/domain/events";
import { nanoSecToDate } from "@/shared/time";

interface EventRowProps {
  event: EventRecord;
  isSelected: boolean;
  numColumns: number;
  onSelect: (event: EventRecord) => void;
}

export const EventRow: React.FC<EventRowProps> = ({
  event,
  isSelected,
  numColumns,
  onSelect,
}) => {
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpandingContent = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <RobotoTableRow hover sx={{ height: "40px" }}>
        <RobotoTableCell
          sx={{
            padding: "0px",
            width: "42.5px",
            maxWidth: "42.5px",
          }}
        >
          <RobotoCheckbox
            sx={{
              ml: theme.spacing(1),
              display: {
                xs: "none",
                sm: "inline-flex",
              },
            }}
            checked={isSelected}
            onChange={() => onSelect(event)}
            color="default"
            inputProps={{ "aria-label": "checkbox" }}
          />
        </RobotoTableCell>
        <RobotoTableCell onClick={toggleExpandingContent}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: theme.spacing(1.5),
            }}
          >
            <TooltipIconButton
              title={expanded ? "Collapse" : "Expand"}
              onClick={toggleExpandingContent}
              sx={{
                padding: theme.spacing(0.25),
              }}
            >
              <ExpandCircleDownOutlinedIcon
                fontSize="small"
                sx={{
                  transform: expanded ? "none" : "rotate(270deg)",
                }}
                color="primary"
              />
            </TooltipIconButton>
            {event.name}
          </Box>
        </RobotoTableCell>
        <RobotoTableCell onClick={toggleExpandingContent}>
          {event.event_id}
        </RobotoTableCell>
        <RobotoTableCell onClick={toggleExpandingContent}>
          <FormattedDateTime value={nanoSecToDate(event.start_time)} />
        </RobotoTableCell>
        <RobotoTableCell onClick={toggleExpandingContent}>
          <RobotoPrincipalUnderlineLink principal={event.created_by} icon />
        </RobotoTableCell>

        <RobotoTableCell onClick={toggleExpandingContent}>
          <EventScope event={event} />
        </RobotoTableCell>

        <RobotoTableCell onClick={toggleExpandingContent}>
          <TagList maxDisplayCount={3} tags={event?.tags} />
        </RobotoTableCell>
      </RobotoTableRow>

      <RobotoTableRow>
        <RobotoTableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            borderWidth: expanded ? "1px" : 0,
          }}
          colSpan={numColumns}
        >
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <EventDetails event={event} />
          </Collapse>
        </RobotoTableCell>
      </RobotoTableRow>
    </>
  );
};
